/** Duy nhất 1 khoá học đã seed trong DB hiện tại — packages/database/prisma/seed/index.ts */
export const DEFAULT_COURSE_ID = 'n5';
